export default "__VITE_ASSET__CZ58Q7ni__"